import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { FileTemplateForm } from './types';

type FileTemplateRow = {
  label: string;
  id: vp.FileTemplateId;
  idFileName?: vp.FileTemplateId;
  require: boolean;
  visible: (ctx: FileTemplateForm) => boolean;
  getSelectOptions: () => { [key: string]: string };
  type: 'input' | 'select' | 'textarea' | 'inputfile';
  preset: keyof vp.TextFieldPresets | undefined;
};
const ProductOptions: { [key: string]: string } = {
  EFT: 'EFT',
  'e-Transfer': 'e-Transfer',
};
const ProductOptionsUs: { [key: string]: string } = {
  ACH: 'ACH',
};
const ServiceOptions: { [key: string]: string } = {
  Debit: 'Debit (Collect Funds)',
  Credit: 'Credit (Send Funds)',
};

export const buildFileUploadRows = (Country: string): FileTemplateRow[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Contacts.DownloadTemplate.Form' });

  return [
    {
      label: t('product', { defaultValue: 'Product' }),
      id: vp.FileTemplateId.Product,
      require: true,
      preset: 'text',
      getSelectOptions: () => (Country === 'US' ? ProductOptionsUs : ProductOptions),
      type: 'select',
      visible: () => true,
    },
    {
      label: t('service', { defaultValue: 'Service' }),
      id: vp.FileTemplateId.Service,
      require: true,
      preset: 'text',
      getSelectOptions: () => ServiceOptions,
      type: 'select',
      visible: () => false,
    },
    {
      label: t('currency', { defaultValue: 'Choose Currency' }),
      id: vp.FileTemplateId.Currency,
      require: true,
      preset: 'text',
      getSelectOptions: () => (Country === 'US' ? vp.US_CURRENCY_ONLY : vp.CA_CURRENCY_ONLY),
      type: 'select',
      visible: () => false,
    },
  ];
};
